'use client';

import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { MobileNavWithTradeProps } from './MobileNavWithTrade';

const MobileNavWithTrade = dynamic(
  () => import('./MobileNavWithTrade').then((m) => m.MobileNavWithTrade),
  { ssr: false, loading: () => null },
);

export default function MobileNavWithTradeDynamic(
  props: MobileNavWithTradeProps,
) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1023.98px)');

    let cancelPending: (() => void) | undefined;

    const onChange = () => {
      if (!mq.matches) return;

      const supportsIdleCallback = 'requestIdleCallback' in window;

      const id = supportsIdleCallback
        ? window.requestIdleCallback(() => setShow(true))
        : setTimeout(() => setShow(true), 200);

      cancelPending = () => {
        if (supportsIdleCallback) {
          window.cancelIdleCallback(id as number);
        } else {
          clearTimeout(id as ReturnType<typeof setTimeout>);
        }
      };
    };

    onChange();

    mq.addEventListener?.('change', onChange);

    return () => {
      mq.removeEventListener?.('change', onChange);

      cancelPending?.();
    };
  }, []);

  if (!show) return null;

  return <MobileNavWithTrade {...props} />;
}
